export default function OutliersIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.33333 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H12C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V8.33333"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.667 12.668C10.667 13.1984 10.8777 13.7071 11.2528 14.0822C11.6279 14.4573 12.1366 14.668 12.667 14.668C13.1974 14.668 13.7061 14.4573 14.0812 14.0822C14.4563 13.7071 14.667 13.1984 14.667 12.668C14.667 12.1375 14.4563 11.6288 14.0812 11.2538C13.7061 10.8787 13.1974 10.668 12.667 10.668C12.1366 10.668 11.6279 10.8787 11.2528 11.2538C10.8777 11.6288 10.667 12.1375 10.667 12.668Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.333 13.9987L13.9997 11.332"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
